<template>
<!-- 订单跟踪页面 -->
    <div class="caseApply">
        <!-- <div class="expressContent">
            <div class="expressCard">
                运单号:
            </div>
            <div class="expressPeople">
                国内承运人:
            </div>
        </div> -->
        
        <van-steps direction="vertical" :active="0" active-color="#1C84F2 " id="myExpressMsg">
            <van-step v-for="item in expressList" :key="item.time">
                <h3>{{item.memo}}</h3>
                <p>{{item.time}}</p>
                <p>{{item.scantype}}</p>
            </van-step>
        </van-steps>
    </div>
</template>
<script>
import ApiSetting from '@/assets/js/api'
export default {
    data(){
        return{
            myOrderDesc:'',
            expressList: [
                // {
                // time: "2015-10-25 17:44:56",
                // scantype: "收件",
                // memo: "【广东广州员村】的收件员【李洪】已收件"
                // }, {
                // time: "2015-10-25 23:03:26",
                // scantype: "发件",
                // memo: "由【广东广州员村】发往【广东广州中转部】"
                // }, {
                // time: "2015-10-30 01:38:17",
                // scantype: "派件",
                // memo: "【广西来宾小平阳营业部】的派件员【姜新笑】正在派件"
                // }, {
                // time: "2015-10-30 01:37:38",
                // scantype: "签收",
                // memo: "已签收,签收人是:【本人签收】"
                // }
            ]
        }
    },
    created(){
        this.myOrderDesc=JSON.parse(sessionStorage.getItem('myOneOrder'))
        this.getExpressMsg()
    },
    methods:{
        getExpressMsg(){
            var param={
                orderId:this.myOrderDesc.order_id
            }
            this.postRequest(ApiSetting.mainInfo,param).then((res) => {
                if(res.data.responseCode=='200'){
                    this.expressList=res.data.data
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
#myExpressMsg{
    /deep/
    .van-step .van-step__circle{
        background-color:#999999 !important;
    }
    .van-step--vertical{
        font-size: 0.24rem;
    }
    .van-step__title{
        p,h3{
            margin: 0;
            padding: 0;
        }
    }
}

.caseApply  {
    .van-steps {
        background-color: #ffffff !important;
    }
    .van-step {
        color: #999999 !important;
    }
    .expressContent{
        background: #ffffff;
        color: #333;
        font-size: 0.28rem;
        margin-bottom: 0.2rem;
        padding:0.2rem 0 0.2rem 0.34rem;
        font-weight: 600;
        .expressCard,.expressPeople{
            height: 0.6rem;
            line-height: 0.6rem;
        }
    }
}
</style>
